import { Label, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProcessCommissionsParameters extends Layout {
    labelParameters: Label;
    textboxBeginDate: Textbox;
    textboxEndDate: Textbox;
    textboxPayee: Textbox;
}
